/*
  Collection filter sidebar (desktop, vertical filter layout)
  - The Filter button in the sort row opens and closes the sidebar.
  - The Designer search box narrows the designer list as you type.
  - When a filter is picked, facets.js re-renders the filter groups. The scroll
    position of each list and any search text are kept so the list doesn't jump.
  Listeners are attached to the document once, so they keep working after
  re-renders and theme editor reloads.
*/
(function () {
  if (window.merdulieCollectionFiltersBound) return;
  window.merdulieCollectionFiltersBound = true;

  var SIDEBAR = '#main-collection-filters';
  var pendingState = null;
  var pendingUntil = 0;

  function normalize(text) {
    return (text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .trim();
  }

  function applySearch(input) {
    var fieldset = input.closest('fieldset');
    if (!fieldset) return;

    var query = normalize(input.value);
    var anyMatch = false;

    fieldset.querySelectorAll('.facets__item').forEach(function (item) {
      var label = item.querySelector('.facet-checkbox__text-label');
      var matches = !query || normalize(label ? label.textContent : item.textContent).indexOf(query) !== -1;
      item.classList.toggle('is-search-hidden', !matches);
      if (matches) anyMatch = true;
    });

    var empty = fieldset.querySelector('.facets__search-empty');
    if (empty) empty.hidden = anyMatch;
  }

  function saveState() {
    var sidebar = document.querySelector(SIDEBAR);
    if (!sidebar) return;

    var state = [];
    sidebar.querySelectorAll('.js-filter[id]').forEach(function (group) {
      var list = group.querySelector('.facets__list--vertical');
      var search = group.querySelector('[data-facet-search]');
      state.push({
        id: group.id,
        scrollTop: list ? list.scrollTop : 0,
        query: search ? search.value : ''
      });
    });

    pendingState = state;
    pendingUntil = Date.now() + 15000;
  }

  function restoreState() {
    if (!pendingState || Date.now() > pendingUntil) {
      pendingState = null;
      return;
    }

    pendingState.forEach(function (entry) {
      var group = document.getElementById(entry.id);
      if (!group) return;

      var search = group.querySelector('[data-facet-search]');
      if (search && entry.query && search.value !== entry.query) {
        search.value = entry.query;
        applySearch(search);
      }

      var list = group.querySelector('.facets__list--vertical');
      if (list && entry.scrollTop && list.scrollTop !== entry.scrollTop) {
        list.scrollTop = entry.scrollTop;
      }
    });
  }

  // Filter button
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-facets-toggle]');
    if (!toggle) return;

    var wrapper = document.querySelector('.facets-vertical--collapsible');
    if (!wrapper) return;

    var isOpen = wrapper.classList.toggle('is-filters-open');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

  // Designer search. Capture phase so typing never reaches the filter form,
  // which would otherwise reload the results on every keystroke.
  document.addEventListener(
    'input',
    function (event) {
      var input = event.target;
      if (!input.matches || !input.matches('[data-facet-search]')) return;
      event.stopPropagation();
      applySearch(input);
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key === 'Enter' && event.target.matches && event.target.matches('[data-facet-search]')) {
        event.preventDefault();
      }
    },
    true
  );

  // Remember list positions right before a filter is applied or removed
  document.addEventListener(
    'change',
    function (event) {
      if (event.target.closest && event.target.closest(SIDEBAR)) saveState();
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      if (event.target.closest && event.target.closest(SIDEBAR + ' facet-remove')) saveState();
    },
    true
  );

  // Put them back as soon as facets.js swaps in the new filter markup
  var observer = new MutationObserver(function () {
    if (pendingState) restoreState();
  });

  function observe() {
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.body) {
    observe();
  } else {
    document.addEventListener('DOMContentLoaded', observe);
  }
})();
